<style>

.about .section-shaped .shape-style-1.shape-primary.wsu {
    /* uigradients.com */
    background: #042D98;
    background-image: url('./../assets/img/vortex.jpg');
    background-repeat: no-repeat;
    background-position: left;
    background-size: cover;
    -webkit-box-shadow: 0px 1px 23px 0px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 1px 23px 0px rgba(0,0,0,0.75);
    box-shadow: 0px 1px 23px 0px rgba(0,0,0,0.75);
}


.about .title {
    color: #ffffff;
}

.about .subtitle {
    color: #e0e1e2;
}

.about .about-body {
    min-height: 700px;
}

.about .loading {
    background-color: #f7f7f7;
}

.about .link {
    cursor: pointer;
}

@media(max-width:575px) {}

@media(min-width:576px) and (max-width:767px) {}

@media(min-width:768px) and (max-width:991px) {}

@media(min-width:992px) and (max-width:1199px) {}

@media(min-width:1200px) {}

</style>

<template>

<div class="about">
    <section class="section section-shaped my-0 pb-xs">
        <div class="shape shape-style-1 shape-primary wsu">
        </div>
        <div class="container">
            <div class="row my-0 py-0">
                <div class="col-lg-12">
                    <h1 class="title text-center my-0 py-0"><center>EDUCATIONAL DATABASE</center></h1>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-2">&nbsp;</div>
                <div class="col-lg-8">
                    <p class="subtitle" v-html="subtitle"></p>
                </div>
            </div>
        </div>
    </section>
    <section class="section about-body">
        <div class="container">
            <div class="row">
                <div class="col-lg-2"></div>
                <div class="col-lg-8" v-if="!loading">
                    <h1>ABOUT</h1>
                    <span class="text-uppercase text-primary">{{title}}</span>
                </div>
                <div class="col-lg-8 loading" v-if="loading">
                    <h1>&nbsp;</h1>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-lg-2"></div>
                <div class="col-lg-8" v-if="!loading" v-html="description"></div>
                <div class="col-lg-8 loading" v-if="loading">
                    <template v-for="i in (1, 8)">
                        <p>&nbsp;</p>
                    </template>
                </div>
            </div>
        </div>
    </section>
</div>

</template>

<script>
import axios from 'axios'

export default {
    created() {
        window.scrollTo(0, 0);
    },
    mounted() {
        if(this.$store.state.subtitle_store)
            this.subtitle = this.$store.state.subtitle_store
        else this.get_page_subtitle()
        this.get_page()
    },
    methods: {
        get_page_subtitle() {
            this.error = null
            axios.get(this.api + 'page/subtitle-pages')
                .then(response => {
                    this.subtitle = response.data.content
                    this.$store.state.subtitle_store = this.subtitle
                })
        },
        get_page() {
            this.error = null
            this.loading = true
            axios.get(this.api + 'page/about')
            .then(response => {
                this.loading = false
                this.title = response.data.title
                this.description = response.data.content
            })
        }
    },
    head: {
        title: function () {
          return {
            inner: 'ABOUT'
          }
        }
    },
    data() {
        return {
            api: require('../../package.json').api,
            subtitle: '',
            error: null,
            loading: false,
            title: '',
            description: ''
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/views/About.vue